import APCommissionsSection from './APCommissionsSection';

export {
  APCommissionsSection
};

export default APCommissionsSection;
